import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import PackageRoomInfo from './PackageRoomInfo';
import {
  getHotelRoulette,
  getHotelTitle,
  getOperatorRoomNameWithRoulette,
} from '../../../store/selectors/hotel';
import { getRoomInfo } from '../../../store/selectors/package';
import { equalsIgnoreCase } from '../../../../../utils/stringUtils';

const mapStateToProps = (state) => {
  const isRoulette = getHotelRoulette(state);
  const roomInfo = getRoomInfo(state);
  const { name_ru, altName, description } = roomInfo;
  const roomType = getOperatorRoomNameWithRoulette(state);
  const roomDescription = isRoulette
    ? getHotelTitle(state)
    : altName || description;
  const isMobile = getIsMobile(state);

  return {
    roomDescription,
    roomType:
      roomType && name_ru && equalsIgnoreCase(name_ru, roomType)
        ? null
        : roomType,
    isMobile,
  };
};

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(PackageRoomInfo);
